"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var ColumnHeader = /** @class */ (function (_super) {
            __extends(ColumnHeader, _super);
            function ColumnHeader(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                if (parent && parent.TypeName === "List") {
                    _this._gridContext = parent;
                }
                if (_this._name === undefined) {
                    _this._name = "";
                }
                _this.ColumnHeaderPopup = $(element).children(".columnHeader-popup")[0];
                // data.DataSource is the headerMetadata pushed from grid
                if (data.DataSource) {
                    _this.FormDataSourceName = data.DataSource.FormDataSourceName;
                    _this.FieldName = data.DataSource.FieldName;
                    _this.IsFilterable = $dyn.computed(function () {
                        return $dyn.value(data.DataSource.IsFilterable) || ($dyn.value(_this.FieldName) === $dyn.util.dataAreaId
                            && parent && $dyn.value(parent.DataSource) && $dyn.value(parent.DataSource)[0] && $dyn.value(parent.DataSource)[0].parent
                            && $dyn.value(parent.DataSource)[0].parent.IsCrossCompany);
                    });
                    _this.IsSortable = data.DataSource.IsSortable;
                    _this.IsFiltered = data.DataSource.IsFiltered;
                    _this.IsSorted = data.DataSource.IsSorted === undefined ? $dyn.ui.SortDirection.none : data.DataSource.IsSorted;
                    _this.IsPrimarySort = data.DataSource.IsPrimarySort || false;
                    _this.Label = data.DataSource.Label;
                    _this.Alignment = data.DataSource.Alignment;
                    _this.ControlType = data.DataSource.ControlType;
                    _this.FilteringFields = data.DataSource.FilteringFields;
                    _this.HelpText = data.DataSource.HelpText;
                }
                _this.FilterExpressions = $dyn.observable(null);
                _this.FlyOutPickerOpen = $dyn.observable(false);
                // If column is not filterable or sortable, skip setting the aria attributes within the flyout binding handler
                _this.skipAriaAttributes = $dyn.computed(function () {
                    return !$dyn.value(_this.IsFilterable) && !$dyn.value(_this.IsSortable);
                });
                _this.sortDirection = $dyn.computed(function () {
                    var _sortDirection = $dyn.ui.SortDirection.none;
                    if ($dyn.value(_this.IsPrimarySort)) {
                        // Only want to show the sort icon on the primary sort
                        _sortDirection = $dyn.value(_this.IsSorted);
                    }
                    return $dyn.util.enumName(_sortDirection, $dyn.ui.SortDirection);
                });
                _this.ShowAddFilterDropDown = $dyn.computed(function () {
                    var flyOutPickerOpen = $dyn.value(_this.FlyOutPickerOpen);
                    return flyOutPickerOpen && ($dyn.value(_this.IsFilterable) || $dyn.value(_this.IsSortable));
                }, function (newValue) {
                    var showDropdown = newValue;
                    if (_this.FilterManager && showDropdown && ($dyn.value(_this.IsFilterable) || $dyn.value(_this.IsSortable))) {
                        _this.FilterManager.getFieldFilters(_this.buildFilteringFieldsSimpleObjectList(), _this.Name, $dyn.value(_this.Label), _this.getFieldFilterCallBack);
                    }
                    else {
                        showDropdown = false; // If the field is not filterable do not show the flyout.
                    }
                    _this.FlyOutPickerOpen(showDropdown);
                    if (_this.Root && _this.Root.element) {
                        if ($dyn.value(_this.FlyOutPickerOpen)) {
                            $(_this.Root.element).on("formClose", _this.CloseFilter);
                        }
                        else {
                            $(_this.Root.element).off("formClose", _this.CloseFilter);
                        }
                    }
                });
                $dyn.observe(_this.FlyOutPickerOpen, function (isOpen) {
                    if (_this.ColumnHeader.length) {
                        if (isOpen) {
                            _this.ColumnHeader.addClass("hasOpenPopup");
                        }
                        else {
                            // clear the aria label of the popup when it closes.
                            var columnHeaderPopupContext = $dyn.context(_this.ColumnHeaderPopup);
                            if (columnHeaderPopupContext) {
                                columnHeaderPopupContext.UpdateColumnHeaderAriaLabel(true);
                            }
                            _this.ColumnHeader.removeClass("hasOpenPopup");
                        }
                    }
                });
                _this.CloseFilter = function () {
                    $dyn.setValue(_this, "ShowAddFilterDropDown", false);
                };
                _this.getFieldFilterCallBack = function (fieldFilterArray) {
                    var validFiltersReturned = true;
                    if (fieldFilterArray && fieldFilterArray.length === _this.FilteringFields.length) {
                        // Array returned from the server should be the same length as the array sent from the client.
                        for (var i = 0; i < fieldFilterArray.length; i++) {
                            if (fieldFilterArray[i] && fieldFilterArray[i].Capability) {
                                var label_1 = $dyn.value(_this.FilteringFields[i].Label);
                                if (label_1) {
                                    // Override the field's label with the control's label in case the label has been overridden on the control level.
                                    $dyn.value(fieldFilterArray[i].Capability).FieldLabel = label_1;
                                }
                            }
                            else {
                                validFiltersReturned = false;
                                break;
                            }
                        }
                    }
                    else {
                        validFiltersReturned = false;
                    }
                    if (validFiltersReturned) {
                        // The filters returned are valid. Show the filters.
                        _this.updateFieldFilterExpressions(fieldFilterArray);
                    }
                    else {
                        // The filters returned are not valid. Close the flyout and log an error.
                        _this.FlyOutPickerOpen(false);
                        $dyn.error({ Message: $dyn.label("List_ColumnNotFilterable"), Label: "List_ColumnNotFilterable" }, _this);
                    }
                    return validFiltersReturned;
                };
                return _this;
            }
            Object.defineProperty(ColumnHeader.prototype, "Name", {
                // Override base control Name getter/setter to not set data-dyn-controlname attribute on the element
                get: function () {
                    return this._name;
                },
                set: function (newName) {
                    this._name = newName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ColumnHeader.prototype, "FilterManager", {
                get: function () {
                    if (!this._filterManager && this.Root) {
                        this._filterManager = this.Root.FilterManager;
                    }
                    return this._filterManager;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ColumnHeader.prototype, "ColumnHeader", {
                get: function () {
                    if (!this._columnHeader) {
                        this._columnHeader = $(this.element).closest(".columnHeader");
                    }
                    return this._columnHeader;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ColumnHeader.prototype, "GridContext", {
                get: function () {
                    if (!this._gridContext) {
                        var $grid = $(this.element).parents("[data-dyn-role='List']");
                        if ($grid.length > 0) {
                            this._gridContext = $dyn.context($grid[0]);
                        }
                    }
                    return this._gridContext;
                },
                enumerable: false,
                configurable: true
            });
            ColumnHeader.prototype.getContextMenuOptions = function () {
                var options = [];
                if (this.GridContext && $dyn.value(this.GridContext.AllowPersonalization) &&
                    this.Root && $dyn.value(this.Root.AllowExplicitPersonalization) && !this.Root.isPopup()) {
                    var hideColumnOption = { Label: $dyn.label("ContextMenu_HideColumn"), Command: this.Hide.bind(this), Enabled: true };
                    options.push(hideColumnOption);
                    var addColumnOption = { Label: $dyn.label("ContextMenu_AddColumns"), Command: this.GridContext.addColumns.bind(this.GridContext), Enabled: true };
                    options.push(addColumnOption);
                }
                options = options.concat(_super.prototype.getContextMenuOptions.call(this));
                return options;
            };
            /** This is called when resize event is fired from the element */
            ColumnHeader.prototype.columnHeaderResizeEventHandling = function (event) {
                // If we're resizing inside a lookup, reflowing the root form will
                // cause the lookup to close in some cases. Set a flag so we can
                // skip the upcoming focus change.
                // Consumed in $dyn.controls.Input.isResizingInLookup
                if (this && this.Root &&
                    this.Root.TypeName === "Popup" &&
                    // If the flag is null, we have consumed and handled it
                    this.Root.popupResizeEventTarget !== null) {
                    this.Root.popupResizeEventTarget = event.target;
                }
                // When column header resizing is done it only changes column width and not the grid control width and nothing on the window changes
                // Hence this event should be stopped from propagating up
                event.stopPropagation();
            };
            /** This is called from the resizable event handler */
            ColumnHeader.prototype.StartColumnHeaderResize = function (event, ui) {
                $dyn.log.list && $dyn.log.list("List: Start column header resize");
                var target = $(event.target);
                if (target.is(".columnHeaderWrapper")) {
                    var columnHeader = $dyn.context(event.target);
                    if (columnHeader && columnHeader.GridContext) {
                        var newColSize = void 0;
                        // because of bug in jquery resize, we need to calculate size
                        // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                        if ($dyn.util.isRTLMode()) {
                            newColSize = ui.originalSize.width + (ui.originalSize.width - ui.size.width);
                        }
                        else {
                            newColSize = ui.originalSize.width + (ui.size.width - ui.originalSize.width);
                        }
                        columnHeader.GridContext.isResizing = true;
                        columnHeader.GridContext._processColumnHeaderResize(event, false, newColSize);
                    }
                }
            };
            ColumnHeader.prototype.StopColumnHeaderResize = function (event, ui) {
                $dyn.log.list && $dyn.log.list("List: Stop column header resize");
                var target = $(event.target);
                if (target.is(".columnHeaderWrapper")) {
                    var columnHeader = $dyn.context(event.target);
                    if (columnHeader && columnHeader.GridContext) {
                        var newColSize = void 0;
                        // because of bug in jquery resize, we need to calculate size
                        // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                        if ($dyn.util.isRTLMode()) {
                            newColSize = ui.originalSize.width + (ui.originalSize.width - ui.size.width);
                        }
                        else {
                            newColSize = ui.originalSize.width + (ui.size.width - ui.originalSize.width);
                        }
                        columnHeader.GridContext._processColumnHeaderResize(event, true, newColSize);
                        columnHeader.GridContext.isResizing = false;
                    }
                }
            };
            /**
             * This method is passed into the simpleFlyout handler of the field selector dropdown to handle click events.
             * @param options An aggregate element that consists of flyout click parameters
             * @returns True if the flyout was closed by the click
             */
            ColumnHeader.prototype.flyoutClickSubscriber = function (options) {
                if ($(options.clickTarget).closest(".flyout-menuItem").length === 1) {
                    return false;
                }
                return $dyn.util.flyout.defaultFlyoutClickSubscriber(options);
            };
            ColumnHeader.prototype.focusIn = function (evt) {
                var _this = this;
                var root = this.Root;
                // Set the server selected control to this column control. This is necessary since the column header itself is not a serverside control,
                // and we may need to execute leave/save boundary logic on the control that is losing focus.
                if (root && root.SetServerSelectedControl && this.Name) {
                    $dyn.setValue(root, "ActiveControl", this.Name);
                    $dyn.async(function () {
                        $dyn.callFunction(root.SetServerSelectedControl, root, [_this.Name]);
                    }, undefined, "Send SetServerSelectedControl to the server");
                }
                if (this.ColumnHeader.length) {
                    this.ColumnHeader.addClass("hasFocus");
                }
                // stop the focus event since it shouldn't bubble up to the form level 'focusIn' handler.
                evt.stopImmediatePropagation();
                evt.preventDefault();
                $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent focusIn from bubbling up from grid column headers.");
            };
            ColumnHeader.prototype.focusOut = function () {
                if (this.ColumnHeader.length) {
                    this.ColumnHeader.removeClass("hasFocus");
                }
            };
            ColumnHeader.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            ColumnHeader.prototype.dispose = function () {
                if (this.ColumnHeaderPopup && !this.ColumnHeaderPopup.hidden) {
                    // ColumnHeaderPopup.hidden attribute is set to false when the columnHeaderPopup gets databound
                    // within the updateFieldFilterExpressions method.
                    $dyn.unbind(this.ColumnHeaderPopup);
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Update the FilterExpressions for this column. Note that this will make the FilterExpressions deeply observable, then show and databind the ColumnHeaderPopup.
             * @param newFilterExpressions A list of FieldFilterExpressions representing the filters for this column
             */
            ColumnHeader.prototype.updateFieldFilterExpressions = function (newFilterExpressions) {
                var filterExpressions = newFilterExpressions;
                if (newFilterExpressions) {
                    var unwrappedFilterExpressions = $dyn.value(newFilterExpressions);
                    unwrappedFilterExpressions.forEach(function (filterExpression) {
                        // Convert the isEditable property from a string to a boolean
                        filterExpression.IsEditable = $dyn.util.stringToBoolean(filterExpression.IsEditable);
                    });
                    // Make filterExpressions deeply observable. Note that we cannot simply make all of the current members of the
                    // filterExpressions observable since actions such as changing to a multi-value operator would not cause the new values
                    // to be observable.
                    var deeplyObservableFilterExpressions = $dyn.observableObject(unwrappedFilterExpressions);
                    filterExpressions = $dyn.value(deeplyObservableFilterExpressions);
                }
                this.FilterExpressions(filterExpressions);
                if (this.element) {
                    this.element.setAttribute("aria-haspopup", "true");
                    if (this.ColumnHeaderPopup.hidden) {
                        $dyn.dataBind(this.ColumnHeaderPopup, this.element.dynContext);
                        this.ColumnHeaderPopup.hidden = false;
                    }
                    // Set the aria-label of the popup to describe the sorts and filters.
                    var columnHeaderPopupContext = $dyn.context(this.ColumnHeaderPopup);
                    if (columnHeaderPopupContext) {
                        columnHeaderPopupContext.UpdateColumnHeaderAriaLabel();
                    }
                }
                else {
                    this.FlyOutPickerOpen(false);
                }
            };
            /**
             * Hides column
             */
            ColumnHeader.prototype.Hide = function () {
                $dyn.callFunction(this.ExecutePersonalizationCommand, this, ["SelectForHide", false]);
                $dyn.callFunction(this.PersistPersonalization, this, [$dyn.ax.personalizableProperties.Visible, false]);
                if (this.Root && this.Root.ShowOrHideHiddenFields) {
                    this.Root.ShowOrHideHiddenFields(false);
                }
            };
            ColumnHeader.prototype.buildFilteringFieldsSimpleObjectList = function () {
                var simpleObjectList = [];
                if (this.FilteringFields) {
                    this.FilteringFields.forEach(function (filteringField) {
                        simpleObjectList.push({ FormDataSourceName: $dyn.value(filteringField.FormDataSourceName), FieldName: $dyn.value(filteringField.FieldName) });
                    });
                }
                return simpleObjectList;
            };
            return ColumnHeader;
        }($dyn.ui.Control));
        controls.ColumnHeader = ColumnHeader;
        ColumnHeader.prototype.FormDataSourceName = "";
        ColumnHeader.prototype.FieldName = "";
        ColumnHeader.prototype.ShowAddFilterDropDown = false;
        ColumnHeader.prototype.IsFilterable = false;
        ColumnHeader.prototype.IsSortable = false;
        ColumnHeader.prototype.IsFiltered = false;
        ColumnHeader.prototype.IsSorted = -1;
        ColumnHeader.prototype.Label = "";
        ColumnHeader.prototype.Alignment = $dyn.ui.autoValue;
        ColumnHeader.prototype.HelpText = "";
        // tslint:disable:object-literal-sort-keys
        var columnHeaderShortcuts = {
            RightArrowResize: {
                Keys: { keyCode: $dyn.ui.KeyCodes.rightArrow },
                Handler: function (evt) {
                    $dyn.log.list && $dyn.log.list("List: Right arrow column resize");
                    if (this && this.element && this.GridContext) {
                        var newColSize = void 0;
                        // because of bug in jquery resize, we need to calculate size
                        // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                        if ($dyn.util.isRTLMode()) {
                            newColSize = this.element.clientWidth - 1;
                        }
                        else {
                            newColSize = this.element.clientWidth + 1;
                        }
                        this.GridContext._processColumnHeaderResize(evt, true, newColSize);
                    }
                },
                Description: function () {
                    var label = $dyn.label("Grid_GrowColumn");
                    if ($dyn.util.isRTLMode()) {
                        label = $dyn.label("Grid_ShrinkColumn");
                    }
                    return label;
                },
            },
            LeftArrowResize: {
                Keys: { keyCode: $dyn.ui.KeyCodes.leftArrow },
                Handler: function (evt) {
                    $dyn.log.list && $dyn.log.list("List: Left arrow column resize");
                    if (this && this.element && this.GridContext) {
                        var newColSize = void 0;
                        // because of bug in jquery resize, we need to calculate size
                        // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                        if ($dyn.util.isRTLMode()) {
                            newColSize = this.element.clientWidth + 1;
                        }
                        else {
                            newColSize = this.element.clientWidth - 1;
                        }
                        this.GridContext._processColumnHeaderResize(evt, true, newColSize);
                    }
                },
                Description: function () {
                    var label = $dyn.label("Grid_ShrinkColumn");
                    if ($dyn.util.isRTLMode()) {
                        label = $dyn.label("Grid_GrowColumn");
                    }
                    return label;
                },
            }
        };
        ColumnHeader.prototype.Shortcuts = $dyn.extendPrototype(ColumnHeader.prototype.Shortcuts, columnHeaderShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ColumnHeader.js.map
